/**
 * @name 组件设置项通用混入文件
 * @author liuguisheng 
 * @version 2019-11-13
 * 
 * 
*/
export default {
    data () {
        return {
            // 计数器组件精度控制
            precision: 2,
            // 计数器组件步数
            step: 0.01
        }
    },
}


// WEBPACK FOOTER //
// ./src/mixins/common/mix_setting_data.js